import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {Observable} from 'rxjs';
import {StorageService} from '../../services/storage/storage.service';
import {UsersService} from '../../services/users/users.service';
import {RouteHelperServiceService} from 'src/app/core/services/routeHelperService/route-helper-service.service';
import {Location} from '@angular/common';
import {AuthService} from './../../services/auth/auth.service';
import {CommonRoutes} from "../../model/enum/routes.enum";


@Injectable({
  providedIn: 'root'
})
export class AuthorizedGuard implements CanActivate {
  constructor(
    private storageService: StorageService,
    private router: Router,
    private usersService: UsersService,
    private routeHelper: RouteHelperServiceService,
    private location: Location,
    private authService: AuthService
  ) {}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const nextUrl = state.url;

    const isAuthorizationPage = nextUrl.includes(CommonRoutes.Authorization);

    if (this.storageService.getToken() && isAuthorizationPage) {
      this.router.navigate([`${this.routeHelper.getRouteBaseOnRole(this.authService.getRole())}`])
      return false;
    }
    return true;
  }

}
